import storage from './storage'
import {routeSorting} from './sorting'

export {
  storage,
  routeSorting
}



/** WEBPACK FOOTER **
 ** ./src/app/utils/index.js
 **/